<script module lang="ts">
  import type { Snippet } from 'svelte';

  export interface Props {
    removeMarginTop?: boolean;
    layerAbs?: boolean;
    children?: Snippet;
  }
</script>

<script lang="ts">
  import { LayerService } from '../../services/LayerService.svelte';

  const { removeMarginTop, layerAbs, children, ...toNext }: Props = $props();

  // -
  const Layer = new LayerService();
  const MyLayer = Layer.upContentLay();
</script>

<div {...toNext} class="contentLayer contentLayer{MyLayer} {removeMarginTop ? 'noMarginTop' : ''} {layerAbs ? 'contentLayerChildAbs' : ''}">
  {@render children?.()}
</div>
